import { SnackBar, SnackBarClass } from '../types';
import { atom } from 'recoil';
import { getUUID } from '../../utils';

export const snackBarState = atom<SnackBar>({
  key: getUUID(),
  default: new SnackBarClass(),
});
